import { render, staticRenderFns } from "./rolepermission.vue?vue&type=template&id=b79534f2"
import script from "./rolepermission.vue?vue&type=script&lang=js"
export * from "./rolepermission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports